import React, {useState} from "react";
import { AnimatePresence, motion } from "framer-motion";
import {Link} from 'react-router-dom';
import { useCartContext } from "../../../context/cartContext";

//comoponente muestra la animacion y ell contenido de os productos que van estar en el carrito
export const CuerpoCarrito =({getUnits, items, total})=>{

       return(     
          <div className="cart-inline">
            <div className="cart-inline-header">
              <h5 className="cart-inline-title">Total Unidades:<span> {getUnits()} </span></h5>
              <h6 className="cart-inline-title">Total:<span>${total()}</span></h6>
            </div>
            {items.map(x=>
            <div className="cart-inline-body" key={x.id}>
              <div className="cart-inline-item">
                <div className="unit unit-spacing-sm align-items-center">
                  <div className="unit-left"><img src={x.imag} className="img-sidebar" alt="producto-carrito"/></div>
                  <div className="unit-body">
                    <h6 className="cart-inline-name">{x.description}</h6>
                    <div>
                      <div className="group-xs group-middle">
                        <div className="table-cart-stepper">
                          Und: {x.qty}
                        </div>
                        <h6 className="cart-inline-title">${x.precio}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
              )}
          </div>
    )
}

export const BuscarOrder=({setSideBar})=>{
  const [orderFire, setOrderFire] = useState({order:''})
  const isDisabled = () => {
    const { order } = orderFire;
    return [order].includes('');
  };
  function onNameChange(evt) {
    setOrderFire({
      ...orderFire,
      [evt.target.name]: evt.target.value
    });
  } 
  return(
    <div className="orderB">
      <p>Quieres ver tu orden?</p>
      <input type="text" name="order" onChange={onNameChange} placeholder="N° de Orden"/>
      <Link to={`/order/${orderFire.order}`}><button className='btn shop' onClick={()=>setSideBar()} disabled={isDisabled()}>Buscar</button></Link>
    </div>
  )
}

const Sidebar=({ sideBar = false, setSideBar = () => {} })=> {
  const {getUnits, items, total,removeItems}= useCartContext();
    return (
      <AnimatePresence>
        {sideBar && (
          <>
            <motion.div
              initial={{ x: "100%" }}
              animate={{
                x: 0
              }}
              exit={{
                x: "100%"
              }}
              transition={{ type: "spring", bounce: 0, duration: 0.4 }}
              className="abierto"
            >
              <button
                onClick={() => setSideBar((sideBar) => !sideBar)}
                className="btn cerrar"
              >
                &times;
              </button>
              {items.length > 0 ? <><CuerpoCarrito {...{getUnits, items, total,removeItems}}/> <Link to={'/cart'}><button className="btn_terminar" onClick={() => setSideBar((sideBar) => !sideBar)}>Terminar Compra!</button></Link></>
              :<>
              <h2 className="text_carrito">Carrito Vacio!</h2>
              <Link to={'/'}><button className="btn_terminar" onClick={() => setSideBar((sideBar) => !sideBar)}>Ir Catalogo</button></Link>
              <BuscarOrder setSideBar={setSideBar}/>
              </>}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    );
}
export default Sidebar;